import SvgIcon from '@mui/material/SvgIcon';
import { SvgIconProps } from '@mui/material/SvgIcon/SvgIcon';

export function TxtIcon(props: SvgIconProps) {
  return (
    <SvgIcon viewBox='0 0 64 80' {...props}>
      <rect width='64' height='80' rx='8' fill='#BDBDBD' />
      <path d='M16 30H48V34H16V30ZM16 38H48V42H16V38ZM16 46H36V50H16V46Z' fill='white' />
      <text x='32' y='22' textAnchor='middle' fill='white' fontSize='14' fontWeight='bold'>
        TXT
      </text>
    </SvgIcon>
  );
}
